import { Avatar } from '@infinitaslearning/il.authentication.avatar';
import { ReactElement, useEffect } from 'react';
import { LicenceSwitcher } from '..';
import { LanguageSwitcher } from '..';
import { useIsWildcardUser } from '../../../hooks';
import { LinkButton } from '../../atoms';
import {
	AppState,
	AppThunkDispatch,
	fetchUserLicenceInfo,
	history,
	UserActions
} from '../../../redux';

import './avatar-wrapper.styles.scss';
import { connect } from 'react-redux';
import { config } from '../../../config';
import { SettingFlags } from '../../../models';
import { useTranslation } from 'react-i18next';
import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import TourIcon from '@mui/icons-material/Tour';
import { Box, Button } from '@material-ui/core';

export interface IAvatarWrapperStateProps {
	userLicences?: string[];
	fetchUserLicences: () => void;
}

function AvatarWrapperView(props: IAvatarWrapperStateProps): ReactElement {
	const { userLicences, fetchUserLicences } = props;
	const { t } = useTranslation('avatar');
	const isWildcardUser = useIsWildcardUser();

	const { value: isContentManagerVisible } = useFeatureFlag(
		SettingFlags.toggleContentManager,
		false
	);

	useEffect(() => {
		fetchUserLicences();
	}, []);

	useEffect(() => {
		if (!userLicences) return;
		if (
			!isWildcardUser &&
			localStorage.getItem(config.selectedLicenceLocalstorageKey) !== null
		) {
			localStorage.removeItem(config.selectedLicenceLocalstorageKey);
			window.location.reload();
		}
	}, [userLicences]);

	return (
		<Avatar>
			<Box display="flex" flexDirection="column" alignItems="flex-start">
			{isContentManagerVisible && (
				<LinkButton
					onClick={() => {
						history.push('/manage');
					}}
				>
					{t('contentManager')}
				</LinkButton>
			)}

			<Button id="usetiful-button" onClick={() => document.getElementById("account_close-menu-btn")?.click()}>
				<TourIcon/>
				{t('tourButton')}
			</Button>
			{isWildcardUser && <LicenceSwitcher />}
			{isWildcardUser && <LanguageSwitcher />}

			</Box>

		</Avatar>
	);
}

function mapStateToProps(state: AppState) {
	return {
		userLicences: state.user.licences
	};
}

function mapDispatchToProps(dispatch: AppThunkDispatch<UserActions>) {
	return {
		fetchUserLicences: () => dispatch(fetchUserLicenceInfo())
	};
}

export const AvatarWrapper = connect(
	mapStateToProps,
	mapDispatchToProps
)(AvatarWrapperView);
